import React from "react";
import makeCarousel from "react-reveal/makeCarousel";
import Slide from "react-reveal/Slide";
import {
  Container,
  Blocks,
  Blocks3,
  Blocks2,
  Blocks4,
  BlocksContainer,
  CarouselBackground,
  FaXTwitter,
} from "./CarouselElements";
import {
  FaInstagram,
  FaTwitter,
  FaSketch,
  FaAws,
  FaReact,
} from "react-icons/fa";
import {
  SiAmazonalexa,
  SiFirebase,
  SiBootstrap,
  SiEthereum,
  SiGooglechrome,
  // SiOpenai,  // Removed – no longer needed
  SiBlender,
  SiUnity,
  SiWeb3Dotjs,
} from "react-icons/si";

import { MdApps } from "react-icons/md";
import { DiOpensource } from "react-icons/di";
import { RiQrCodeLine } from "react-icons/ri";
import { GiArtificialIntelligence } from "react-icons/gi";
import { TiCss3 } from "react-icons/ti";

const RevealCarousel = () => {
  const CarouselUI = ({ children }) => <Container>{children}</Container>;
  const Carousel = makeCarousel(CarouselUI);

  return (
    <>
      <CarouselBackground>
        <Carousel
          defaultWait={3000}
          maxTurns={100} /*wait for 3000 milliseconds*/
          
        >
          <Slide right>
            <BlocksContainer>
              <Blocks>
                {/* Replaced SiOpenai with Grok SVG */}
                <img
                  src="/images/icons/grok.svg"  // Path from public folder
                  alt="Grok xAI"
                  width={42}
                  height={42}
                  style={{
                    // Optional: Ensure it matches color and alignment
                    filter: 'brightness(0) saturate(100%)',  // Forces black if SVG has color
                    verticalAlign: 'middle'  // Aligns with other icons if needed
                  }}
                />
              </Blocks>
              <Blocks3>
                <GiArtificialIntelligence color="#010606" size={42} />
              </Blocks3>
               <Blocks2>
                <SiFirebase color="#010606" size={42} />
              </Blocks2>
            </BlocksContainer>
          </Slide>
          <Slide right>
            <BlocksContainer>
              <Blocks2>
                <SiWeb3Dotjs color="#010606" size={42} />
              </Blocks2>
              <Blocks3>
                <FaReact color="#010606" size={42} />
              </Blocks3>
              <Blocks>
                <SiEthereum color="#010606" size={42} />
              </Blocks>
            </BlocksContainer>
          </Slide>
          <Slide right>
            <BlocksContainer>
              <Blocks2>
                <FaSketch color="#010606" size={42} />
              </Blocks2>
              <Blocks3>
                <SiBlender color="#010606" size={42} />
              </Blocks3>
              <Blocks>
                <SiUnity color="#010606" size={42} />
              </Blocks>
            </BlocksContainer>
          </Slide>
        </Carousel>
      </CarouselBackground>
    </>
  );
};

export default RevealCarousel;